import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

    constructor(@Inject(OKTA_AUTH)private readonly oktaAuth: OktaAuth) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const accessToken = this.oktaAuth.getAccessToken();

        let request = req;

        if (accessToken) {
            request = req.clone({
                setHeaders: {
                    authorization: `Bearer ${accessToken}`
                }
            });
        }

        return next.handle(request);
    }
}
